<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      type="text"
      class="form-control"
      @change="emit"
      @input="emit"
      @blur="emit"
    />
    <div v-if="!isView && !['pedestrian', 'bike'].includes(transport.type)">
      <a
        v-if="isFilledVisitorName"
        class="transport-owner-helpers"
        @click="setTransportOwner(visitorName)"
      >{{ visitorName }}</a>
      <span>&nbsp;</span>
      <a
        v-if="form.organization.name"
        class="transport-owner-helpers"
        @click="setTransportOwner(form.organization.name)"
      >{{ form.organization.name }}</a>
      <span>&nbsp;</span>
      <a
        v-if="visitor.personal.organization_name"
        class="transport-owner-helpers"
        @click="setTransportOwner(visitor.personal.organization_name)"
      >{{ visitor.personal.organization_name }}</a>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportOwnerInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Собственник ТС'
    },

    inputName: {
      default: 'owner'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      return `form-visitor-transport-owner-${this.visitorIndex}-${this.transportIndex}`
    },

    isFilledVisitorName() {
      return this.visitor.personal.fullname_last ||
        this.visitor.personal.fullname_first ||
        this.visitor.personal.fullname_patronymic
    },

    visitorName() {
      let fullName = this.visitor.personal.fullname_last

      if (this.visitor.personal.fullname_first !== null) {
        fullName += (fullName !== '' ? ' ' : '') + this.visitor.personal.fullname_first
      }

      if (this.visitor.personal.fullname_patronymic !== null) {
        fullName += (fullName !== '' ? ' ' : '') + this.visitor.personal.fullname_patronymic
      }

      return fullName
    }
  },

  methods: {
    setTransportOwner(owner) {
      this.inputValue = owner
    }
  }
}
</script>
